import React, { useState } from "react";
import "./DetailsDesc.css";
import { Grid } from "@mui/material";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";

const DetailsDesc = () => {
  const [crew, setCrew] = useState(0);
  const [cap, setCap] = useState(0);
  const [hours, setHours] = useState(0);
  const [km, setKm] = useState(0);
  const [total, setTotal] = useState(0);
  const [windowWidth, setWindowWidth] = useState(window.outerWidth);

  window.addEventListener("resize", function () {
    setWindowWidth(window.outerWidth);
  });

  const handleTotal = (amt)=>{

    if(total-amt >=0){
      setTotal(total-amt)
    }else{
      setTotal(0)
    }

  }

  return (
    <div className="detailsDescMain">
      <Grid container>
        <Grid item xs={12} sm={4} md={6}>
          <p
            style={{
              fontWeight: 700,
              fontSize: 22,
              textAlign: "left",
              marginTop: 30,
            }}
          >
            Description
          </p>
          <p style={{ textAlign: "left" }}>
            Ut consectetur esse id sit magna tempor ad occaecat sit minim irure.
            Ut consectetur esse id sit magna tempor ad occaecat sit minim
            irure.Ut consectetur esse id sit magna tempor ad occaecat sit minim
            irure. Ut consectetur esse id sit magna tempor ad occaecat sit minim
            irure.Ut consectetur esse id sit magna tempor ad occaecat sit minim
            irure.
          </p>
          <p style={{ textAlign: "left" }}>
            Ut consectetur esse id sit magna tempor ad occaecat sit minim irure.
            Ut consectetur esse id sit magna tempor ad occaecat sit minim
            irure.Ut consectetur esse id sit magna tempor ad occaecat sit minim
            irure.
          </p>
        </Grid>
        <Grid item xs={12} sm={8} md={6} mt={7} mb={3}>
          <div className="DetCalcMain">
            <div className="calcCrewDiv">
              <span>No. of crew</span>
              <div className="calcProDiv">
                <div
                  className="CalcMinus"
                  onClick={() => {
                    if (crew > 0) {
                      setCrew(crew - 1);
                      handleTotal(100)
                      // setTotal(total - 100);
                    }
                  }}
                >
                  <span>-</span>
                </div>
                <span className="numDetDesc numDetDescMargin">{crew}</span>
                <div
                  className="CalcPlus"
                  onClick={() => {
                    setCrew(crew + 1);
                    setTotal(total + 100);
                  }}
                >
                  <span>+</span>
                </div>
              </div>
            </div>
            <hr />
            <div className="calcCapDiv">
              <span>No. of Captain</span>
              <div className="calcProDiv">
                <div
                  className="CalcMinus"
                  onClick={() => {
                    if (cap > 0) {
                      setCap(cap - 1);
                      // setTotal(total - 150);
                      handleTotal(150)
                    }
                  }}
                >
                  <span>-</span>
                </div>
                <span className="numDetDesc numDetDescMargin">{cap}</span>
                <div
                  className="CalcPlus"
                  onClick={() => {
                    setCap(cap + 1);
                    setTotal(total + 150);
                  }}
                >
                  <span>+</span>
                </div>
              </div>
            </div>
            <hr />
            <div className="calcCapDiv">
              <span>No. of Hours</span>
              <div className="calcProDiv">
                <div
                  className="CalcMinus"
                  onClick={() => {
                    if (hours > 0) {
                      setHours(hours - 1);
                      // setTotal(total - 200);
                      handleTotal(200)
                    }
                  }}
                >
                  <span>-</span>
                </div>
                <span className="numDetDesc numDetDescMargin">{hours}</span>
                <div
                  className="CalcPlus"
                  onClick={() => {
                    setHours(hours + 1);
                    setTotal(total + 200);
                  }}
                >
                  <span>+</span>
                </div>
              </div>
            </div>

            <hr />
            <div className="calcCapDiv">
              <span>Total Distance</span>
              <div className="calcProDiv">
                <div className="CalcRange">
                  <Slider
                    value={km}
                    min={0}
                    max={50}
                    onChange={(val) => {
                      if (km < val) {
                        setTotal(total + 50);
                      } else {
                      handleTotal(50)
                      // setTotal(total - 50);
                      }
                      setKm(val);
                    }}
                    allowCross={false}
                    className="slider"
                    // defaultValue={10}
                  />
                </div>
                <span className="numDetDesc kmDesc">{km} Km</span>
              </div>
            </div>

            <hr />
            <div className="calcCapDiv">
              <span>Total</span>
              <span className="numDetDesc numDetDescTotal">
                $ {total}
              </span>
            </div>

            <hr />
            <div className=" payButton">
              <span>Proceed To Pay</span>
            </div>

          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default DetailsDesc;
